import { Injectable } from '@angular/core';

export type SparkModeKey = 'standard' | 'academy';

@Injectable({
  providedIn: 'root',
})
export class AcademyModeService {
  private readonly storageKey = 'sparkAcademyMode';

  syncFromCurrentUrl(): boolean {
    const modeFromUrl = this.getAcademyModeFromUrl();
    if (modeFromUrl != null) {
      this.setAcademyMode(modeFromUrl);
      return modeFromUrl;
    }

    return this.isAcademyModeEnabled();
  }

  isAcademyModeEnabled(): boolean {
    return sessionStorage.getItem(this.storageKey) === '1';
  }

  setAcademyMode(isAcademyMode: boolean): void {
    sessionStorage.setItem(this.storageKey, isAcademyMode ? '1' : '0');
  }

  getModeKey(): SparkModeKey {
    return this.isAcademyModeEnabled() ? 'academy' : 'standard';
  }

  getAcademyModeQueryParams(): { academyMode?: number } {
    return this.isAcademyModeEnabled() ? { academyMode: 1 } : {};
  }

  appendModeToPath(path: string): string {
    if (!this.isAcademyModeEnabled()) {
      return path;
    }

    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}academyMode=1`;
  }

  appendModeToApiUrl(url: string): string {
    if (!this.isAcademyModeEnabled() || url.includes('academyMode=')) {
      return url;
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}academyMode=1`;
  }

  private getAcademyModeFromUrl(): boolean | null {
    const academyModeFromUrl = new URLSearchParams(window.location.search).get(
      'academyMode'
    );
    if (academyModeFromUrl == null) {
      return null;
    }

    const normalizedAcademyMode = academyModeFromUrl.toLowerCase();
    return normalizedAcademyMode === '1' || normalizedAcademyMode === 'true';
  }
}
